import React, { useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useElementDimensions } from "@sportal/cdk/hooks";

import { WebFilterOffNotification } from "./WebFilterOffNotification";
import { getSBEnabledStatus } from "../../../store/account";
import { setStaticNotificationHeight } from "../../../store/layout";

import "./StaticNotifications.scss";

export const staticNotificationClassName = "static-notifications";

export const StaticNotifications = () => {
  const notificationRef = useRef();
  const dispatch = useDispatch();
  const isSBEnabled = useSelector(getSBEnabledStatus);
  const { height } = useElementDimensions(notificationRef);

  useLayoutEffect(() => {
    dispatch(setStaticNotificationHeight(height));
  }, [dispatch, height]);

  return (
    <div className={staticNotificationClassName} ref={notificationRef}>
      {!isSBEnabled && (
        <div className={`${staticNotificationClassName}__web-filter-off`}>
          <WebFilterOffNotification />
        </div>
      )}
    </div>
  );
};
